<template>
  <div v-if="users">
    <h1 style="margin: 0 0 4px">Users</h1>
    <div class="d-flex justify-content-between align-items-start mb-2">
      <hilo-button label="Add +" @click="navigateToAddUser" />
      <input
        class="search-input"
        v-model="search"
        placeholder="Search"
        @input="filterUsers"
      />
    </div>
    <hilo-table :columns="columns" :data="filteredUsers" />
  </div>
</template>

<script>
import UsersAPIService from "../../../../servicehandlers/UsersAPIService";
import HiloTable from "../../../../components/HiloComponents/HiloTable.vue";
import HiloButton from "../../../../components/HiloComponents/HiloButton.vue";
const usersAPIService = new UsersAPIService();

export default {
  name: "Users",
  components: {
    HiloButton,
    HiloTable,
  },
  data() {
    return {
      username: null,
      firstName: null,
      lastName: null,
      password: null,
      email: "",
      phone: "",
      newUser: {
        username: "",
        email: "",
        password: "",
        confirmPassword: "",
        firstName: "",
        lastName: "",
        phone: "",
        sms: "",
        active: true,
        notify: true,
      },
      users: [],
      filteredUsers: [],
      userTypes: [],
      search: "",
      columns: [
        {
          key: "id",
          component: "HiloButton",
          componentProps: (row) => ({
            styleType: "editIcon",
            onClick: () => this.navigateToEditUser(row.id),
          }),
        },
        { key: "username", label: "Username" },
        { key: "email", label: "Email" },
        { key: "firstName", label: "First" },
        { key: "lastName", label: "Last" },
        { key: "userType", label: "User Type" },
        { key: "phone", label: "Phone" },
      ],
    };
  },
  mounted() {
    this.getAllUsers();
    this.getUserTypes();
  },
  methods: {
    arePasswordsSame() {
      return this.newUser.password === this.newUser.confirmPassword;
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    savePassword(id, password) {
      this.editingPasswordForUserId = null;
      const user_password = {
        id,
        password,
      };
      return usersAPIService
        .update(id, user_password)
        .then(() => {})
        .catch((error) => {});
    },
    getAllUsers() {
      return usersAPIService
        .get(this.$router)
        .then((allUsers) => {
          this.users = allUsers.map((user) => {
            return {
              ...user,
              phone: this.formattedPhone(user.phone),
              userType: user.userType?.name || "Unknown",
            };
          });
          this.filteredUsers = this.users;
        })
        .catch((error) => {});
    },
    formattedPhone(phone) {
      if (!phone) return "";
      const cleaned = phone.replace(/\D/g, "");
      const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phone;
    },
    filterUsers() {
      const searchTerm = this.search.toLowerCase();
      const columnKeys = this.columns.map((column) => column.key);
      this.filteredUsers = this.users.filter((user) => {
        return columnKeys.some((key) => {
          const value = user[key];
          return value && value.toString().toLowerCase().includes(searchTerm);
        });
      });
    },
    navigateToAddUser() {
      this.$router.push({ name: "Add Edit User" });
    },
    navigateToEditUser(id) {
      this.$router.push({ name: "Add Edit User", params: { id } });
    },
    getUserTypes() {
      return usersAPIService
        .getUserTypes(this.$router)
        .then((types) => {
          this.userTypes = types;
        })
        .catch((error) => {});
    },
    validatePassword() {
      const password = this.newUser.password;
      const capitalLetter = /[A-Z]/;
      const numberRegex = /[0-9]/;
      const specialCharacter = /[~!@#$%^&*()_+{}|:"<>?]/;
      if (!capitalLetter.test(password)) {
        Message.error("Password must include at least one capital letter");
        return false;
      } else if (!numberRegex.test(password)) {
        Message.error("Password must include at least one number");
        return false;
      } else if (!specialCharacter.test(password)) {
        Message.error("Password must include at least one special character");
        return false;
      } else {
        this.passwordError = "";
        return true;
      }
    },
    create() {
      if (!this.validatePassword()) {
        return;
      }
      if (this.arePasswordsSame()) {
        this.passwordError = ""; // Clear any previous error message.
      } else {
        this.passwordError = "Passwords do not match.";
        return;
      }
      if (!this.newUser.email) {
        this.handleError("No user email!");
        return;
      }
      if (!this.newUser.password) {
        this.handleError("No user password!");
        return;
      }
      if (!this.newUser.firstName) {
        this.handleError("No user first name!");
        return;
      }
      if (!this.newUser.lastName) {
        this.handleError("No user last name!");
        return;
      }
      this.closeModal("create_user");
      this.spinning = true;
      return usersAPIService
        .checkUsername(this.newUser.username)
        .then((response) => {
          if (parseInt(response) === 1) {
            this.error_txt = "Username is already taken!";
            this.openModal("error");
            this.spinning = false;
          } else {
            const user = {
              username: this.username,
              email: this.email,
              firstName: this.firstName,
              lastName: this.lastName,
              phone: this.phone,
              password: this.password,
              confirmPassword: this.confirmPassword,
            };
            return usersAPIService
              .create(this.newUser, this.$router)
              .then((newUser) => {
                this.active = true;
                this.spinning = false;
                this.success_txt = "Successfully created user: ";
                this.openModal("success");
                this.newUser.username = "";
                this.newUser.password = "";
                this.newUser.confirmPassword = "";
                this.newUser.firstName = "";
                this.newUser.lastName = null;
                this.newUser.phone = "";
                this.newUser.enabled = true;
                this.spinning = false;
                this.searchUserTerm = null;
                this.getAllUsers();
              })
              .catch((error) => {
                this.spinning = false;
                this.error_txt = "Error creating user: " + error;
                this.openModal("error");
              });
          }
        });
    },
  },
};
</script>

<style scoped></style>
